import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { TrendingUp, ChartBar, Award } from 'lucide-react';
import HeroSection from '../components/ui/HeroSection';
import HeroCard from '../components/ui/HeroCard';
import Section from '../components/ui/Section';
import InvestorAccessModal from '../components/investor/InvestorAccessModal';
import InvestmentOverview from '../components/investor/InvestmentOverview';
import MarketOpportunity from '../components/investor/MarketOpportunity';
import CompetitiveAdvantage from '../components/investor/CompetitiveAdvantage';
import TeamSection from '../components/investor/TeamSection';
import FaqSection from '../components/investor/FaqSection';

const InvestorPage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Check if user has been verified
    const isVerified = sessionStorage.getItem('investorVerified') === 'true';
    if (!isVerified) {
      setShowModal(true);
    }
    
    // Ensure we scroll to top when this component mounts
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div id="top" className="font-sans text-black">
      <InvestorAccessModal isOpen={showModal} onClose={handleCloseModal} />
      
      {/* Hero Section */}
      <HeroSection
        title="Investor Information"
        description="Join us in revolutionizing healthcare with the world's first Large Biosignal Model, powering the next generation of medical devices for early disease detection and proactive care."
        buttonText="Request Investor Deck"
        buttonLink="/contact"
        buttonVariant="primary"
        buttonScrollTo=""
        centered={false}
        paddingY="py-32"
      >
        <HeroCard 
          icon={<TrendingUp className="h-20 w-20 text-primary" />}
          title="£10M Series A Round"
          description="We're raising £10 million to scale our technology, achieve regulatory milestones, and accelerate market adoption."
        />
      </HeroSection>
      
      <Section>
        <div className="container mx-auto px-6">

        {/* Tab Navigation */}
        <div className="flex flex-wrap border-b border-gray-200 mb-8">
          <button 
            className={`mr-4 py-2 px-4 font-medium ${activeTab === 'overview' ? 'text-primary border-b-2 border-primary' : 'text-gray-500 hover:text-primary'}`}
            onClick={() => setActiveTab('overview')}
          >
            Overview
          </button>
          <button 
            className={`mr-4 py-2 px-4 font-medium ${activeTab === 'market' ? 'text-primary border-b-2 border-primary' : 'text-gray-500 hover:text-primary'}`}
            onClick={() => setActiveTab('market')}
          >
            Market Opportunity
          </button>
          <button 
            className={`mr-4 py-2 px-4 font-medium ${activeTab === 'advantage' ? 'text-primary border-b-2 border-primary' : 'text-gray-500 hover:text-primary'}`}
            onClick={() => setActiveTab('advantage')}
          >
            Competitive Advantage
          </button>
          <button 
            className={`mr-4 py-2 px-4 font-medium ${activeTab === 'team' ? 'text-primary border-b-2 border-primary' : 'text-gray-500 hover:text-primary'}`}
            onClick={() => setActiveTab('team')}
          >
            Team
          </button>
          <button 
            className={`mr-4 py-2 px-4 font-medium ${activeTab === 'faq' ? 'text-primary border-b-2 border-primary' : 'text-gray-500 hover:text-primary'}`}
            onClick={() => setActiveTab('faq')}
          >
            FAQ
          </button>
        </div>

        {/* Tab Content */}
        {activeTab === 'overview' && <InvestmentOverview />}
        {activeTab === 'market' && <MarketOpportunity />}
        {activeTab === 'advantage' && <CompetitiveAdvantage />}
        {activeTab === 'team' && <TeamSection />}
        {activeTab === 'faq' && <FaqSection />}
      </div>
      </Section>
    </div>
  );
};

export default InvestorPage;